import e from "react";
import { getIconColor as d } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const r = {
  display: "block"
}, h = ({ size: a = 16, useVw: l, useRem: n, color: c, withColor: o, removeClassName: t, disableSSR: m, style: i, ...p }) => {
  const v = i ? { ...r, ...i } : r;
  return /* @__PURE__ */ e.createElement(f, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-qiquan", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: l ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (n ? "rem" : "px"), height: l ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (n ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: v, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: t ? "" : "32px-ææ"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: o ? d(c, 0, "#262933") : "#262933",
        datafollowfill: o ? d(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M8.34 5.1A4.74 4.74 0 0 0 3.6 9.84v12.32a4.74 4.74 0 0 0 4.74 4.74h6.24a.9.9 0 1 0 0-1.8H8.34a2.94 2.94 0 0 1-2.94-2.94V9.84A2.94 2.94 0 0 1 8.34 6.9h.063a.91.91 0 0 0-.002.06v6.153c0 .502.188 1.079.727 1.396.538.316 1.132.2 1.57-.04l.004-.003 1.517-.845 1.517.845.004.002c.438.242 1.032.357 1.57.04.54-.316.727-.893.727-1.395V6.96c0-.02 0-.04-.002-.06H23.7a2.94 2.94 0 0 1 2.94 2.94V14a.9.9 0 1 0 1.8 0V9.84A4.74 4.74 0 0 0 23.7 5.1H8.34Zm5.899 1.8h-4.04l.002.06v5.725l1.269-.707c.252-.139.525-.183.749-.183.224 0 .497.044.75.183l.005.003 1.263.704V6.96c0-.02 0-.04.002-.06Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M22.422 23.083a.9.9 0 0 1-.9-.9v-2.047a.9.9 0 1 1 1.8 0v1.147h1.147a.9.9 0 0 1 0 1.8h-2.047Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M22.74 27.52a5.76 5.76 0 1 0 0-11.52 5.76 5.76 0 0 0 0 11.52Zm0-1.8a3.96 3.96 0 1 0 0-7.92 3.96 3.96 0 0 0 0 7.92Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, g = h;
export {
  g as default
};
